import { render } from "./authors.vue?vue&type=template&id=3fdf672a&scoped=true"
import script from "./authors.vue?vue&type=script&lang=js"
export * from "./authors.vue?vue&type=script&lang=js"

import "./authors.vue?vue&type=style&index=0&id=3fdf672a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fdf672a"

export default script